import { call, put } from "redux-saga/effects";

import { apiFoco, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";

import { requestErrorHandler } from "utils";
import { CreateContactActions } from "store/ducks/contact";

export function* CreateContactRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;
    const { data } = yield call(apiFoco.post, `/contact`, postData);

    yield put(CreateContactActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateContactActions.failure(errorMessage));
  }
}
